export const CACHE_KEYS = {
  dashboardStats: 'dashboard:stats',
  pendingProducts: 'pending-products:list',
  users: 'users:list',
  lastProductId: 'products:last-id',
  barcodeExists: 'barcodes:exists-set',
  searchPrefix: 'products:search:',
} as const;

export const buildSearchCacheKey = (filter: {
  searchTerm?: string;
  category?: string;
  status?: string;
}): string =>
  CACHE_KEYS.searchPrefix +
  JSON.stringify({
    searchTerm: filter.searchTerm ?? '',
    category: filter.category ?? '',
    status: filter.status ?? '',
  });
